import React from 'react';
// allows using `map` on a dictionary
import map from 'lodash.map';
import TeamsType from '../../../../lib/proptypes/teams';
import classes from './desktopNav.css';
import { SORTED_DIVISIONS } from '../../../../store/actions/teams.types';
import { NavLink } from '../../../../lib/components/link';
import { viewTeam } from '../../../views/Team/module/team';

// This creates a div with the Conference/Division name, and the list of the teams
const TeamsByDivision = (conference, conferenceName, divisionName) => (
  <div key={`${conferenceName} ${divisionName}`}>
    <div className={classes.teamsDivisionName}>
      {`${conferenceName} ${divisionName}`}
    </div>
    {conference.map(team => {
      if (team.name != 'Agent')
        return (
      (<NavLink
        action={viewTeam({ id: team.id, teamName: team.slug })}
        className={classes.teamNameLink}
        activeClassName={classes.activeTeamNameLink}
        key={team.id}
        down
        exact
      >
        {team.city} {team.name}
      </NavLink>)
      )})
    }
  </div>);

// This arranges the four divisions into two columns, which are then placed into spans
const ArrangeDivisions = (conference, conferenceName, sortedDivisions) => {
  const column = [[], []];
  sortedDivisions.forEach((division, i) => {
    column[Math.floor(i / 2)].push(
      TeamsByDivision(conference[division], conferenceName, division),
    );
  });
  return column;
};

const DesktopTeamMenu = ({ teams: league }) => (
  <div className="teams" style={{ display: 'flex', width: '100%' }}>
    {map(league, (conference, conferenceName) =>
      ArrangeDivisions(conference, conferenceName, SORTED_DIVISIONS).map(item => (
        <span className={classes.teamsColumn}>
          {item}
        </span>),
      ),
    )}
  </div>
);

DesktopTeamMenu.propTypes = {
  teams: TeamsType.isRequired,
};

export default DesktopTeamMenu;



// WEBPACK FOOTER //
// ./src/app/components/Nav/DesktopNav/DesktopTeamMenu.js